import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import {handleErrorResponse} from "../utils/util"
import { USER_ROLE } from "../constants/index"
import { JobService, MasterService } from "../api/services.gen";
import {
  MasterOptionsMasterListData,
  JobCreateCreateData,
  JobListData,
  JobDestroyData,
  JobUpdateData,
  JobDetailRetrieveData,
  JobDetailUpdateData,
  JobImportCreateData,
  JobTempRetrieveData,
  JobTempDestroyData,
  JobSaveImportCreateData,
  JobSaveImportPublicCreateData,
  JobSaveImportPublicUpdateData,
  JobImportRecordCreateData,
  JobImportRecordUpdateData,
  JobOptionRelatedRetrieveData,
} from "../api/types.gen";
import i18n from 'i18next';
import { resetAppState } from "../store/common";

export const getOptionsMaster = createAsyncThunk(
  "getOptionsMaster",
  async (data: JobOptionRelatedRetrieveData, thunkAPI: any) => {
    try {
      const res: any = await JobService.jobOptionRelatedRetrieve(data);
      if (res.success) {
        return res.data;
      } else {
        if(res.message) return thunkAPI.rejectWithValue(res.message);
        else return thunkAPI.rejectWithValue(i18n.t('MSG_GLOBAL_DATA_LOAD_FAILED'));
      }
    } catch (error: any) {
      return handleErrorResponse(error, USER_ROLE.COMPANY, thunkAPI);
    }
  },
);

export const getProfessionList = createAsyncThunk(
  "getProfessionList",
  async (_, thunkAPI: any) => {
    try {
      const res: any = await JobService.jobProfessionListList();
      if (res.success) {
        return res.data;
      } else {
        if(res.message) return thunkAPI.rejectWithValue(res.message);
        else return thunkAPI.rejectWithValue(i18n.t('MSG_GLOBAL_DATA_LOAD_FAILED'));
      }
    } catch (error: any) {
      return handleErrorResponse(error, USER_ROLE.COMPANY, thunkAPI);
    }
  },
);

export const getIndustryList = createAsyncThunk(
  "getIndustryList",
  async (_, thunkAPI: any) => {
    try {
      const res: any = await JobService.jobIndustryListList();
      if (res.success) {
        return res.data;
      } else {
        if(res.message) return thunkAPI.rejectWithValue(res.message);
        else return thunkAPI.rejectWithValue(i18n.t('MSG_GLOBAL_DATA_LOAD_FAILED'));
      }
    } catch (error: any) {
      return handleErrorResponse(error, USER_ROLE.COMPANY, thunkAPI);
    }
  },
);

export const createJob = createAsyncThunk(
  "createJob",
  async (data: JobCreateCreateData, thunkAPI: any) => {
    try {
      const res: any = await JobService.jobCreateCreate(data);
      if (res.success) {
        return res;
      } else {
        if(res.message) return thunkAPI.rejectWithValue(res.message);
        else return thunkAPI.rejectWithValue(i18n.t('MSG_GLOBAL_DATA_LOAD_FAILED'));
      }
    } catch (error: any) {
      return handleErrorResponse(error, USER_ROLE.COMPANY, thunkAPI);
    }
  },
);

export const getJobList = createAsyncThunk(
  "getJobList",
  async (data: JobListData, thunkAPI: any) => {
    try {
      const res: any = await JobService.jobList(data);
      if (res.results.success) {
        return res;
      } else {
        if(res.message) return thunkAPI.rejectWithValue(res.message);
        else return thunkAPI.rejectWithValue(i18n.t('MSG_GLOBAL_DATA_LOAD_FAILED'));
      }
    } catch (error: any) {
      if(error.status == 404){
        return thunkAPI.dispatch(setCurrentPage(thunkAPI.getState().companyJob.currentPage - 1));
      }
      return handleErrorResponse(error, USER_ROLE.COMPANY, thunkAPI);
    }
  },
);

export const deleteJobByIds = createAsyncThunk(
  "deleteJobByIds",
  async (data: JobDestroyData, thunkAPI: any) => {
    try {
      const res: any = await JobService.jobDestroy(data);
      if (res) {
        return res;
      } else {
        if(res.message) return thunkAPI.rejectWithValue(res.message);
        else return thunkAPI.rejectWithValue(i18n.t('MSG_GLOBAL_DATA_LOAD_FAILED'));
      }
    } catch (error: any) {
      return handleErrorResponse(error, USER_ROLE.COMPANY, thunkAPI);
    }
  },
);

export const updateJobStatus = createAsyncThunk(
  "updateJobStatus",
  async (data: JobUpdateData, thunkAPI: any) => {
    try {
      const res: any = await JobService.jobUpdate(data);
      if (res.success) {
        return res.message;
      } else {
        if(res.message) return thunkAPI.rejectWithValue(res.message);
        else return thunkAPI.rejectWithValue(i18n.t('MSG_GLOBAL_DATA_LOAD_FAILED'));
      }
    } catch (error: any) {
      return handleErrorResponse(error, USER_ROLE.COMPANY, thunkAPI);
    }
  },
);

export const getJobDetail = createAsyncThunk(
  "getJobDetail",
  async (data: JobDetailRetrieveData, thunkAPI: any) => {
    try {
      const res: any = await JobService.jobDetailRetrieve(data);
      if (res.id) {
        return res;
      } else {
        if(res.message) return thunkAPI.rejectWithValue(res.message);
        else return thunkAPI.rejectWithValue(i18n.t('MSG_GLOBAL_DATA_LOAD_FAILED'));
      }
    } catch (error: any) {
      return handleErrorResponse(error, USER_ROLE.COMPANY, thunkAPI);
    }
  },
);

export const updateJobDetail = createAsyncThunk(
  "updateJobDetail",
  async (data: JobDetailUpdateData, thunkAPI: any) => {
    try {
      const res: any = await JobService.jobDetailUpdate(data);
      if (res.success) {
        return res;
      } else {
        if(res.message) return thunkAPI.rejectWithValue(res.message);
        else return thunkAPI.rejectWithValue(i18n.t('MSG_GLOBAL_DATA_LOAD_FAILED'));
      }
    } catch (error: any) {
      return handleErrorResponse(error, USER_ROLE.COMPANY, thunkAPI);
    }
  },
);

export const importJobTemp = createAsyncThunk(
  "importJobTemp",
  async (data: JobImportCreateData, thunkAPI: any) => {
    try {
      const res: any = await JobService.jobImportCreate(data);
      if (res.success) {
        return res;
      } else {
        if(res.message) return thunkAPI.rejectWithValue(res.message);
        else return thunkAPI.rejectWithValue(i18n.t('MSG_GLOBAL_DATA_LOAD_FAILED'));
      }
    } catch (error: any) {
      return handleErrorResponse(error, USER_ROLE.COMPANY, thunkAPI);
    }
  },
);

export const getJobDetailTemp = createAsyncThunk(
  "getJobDetailTemp",
  async (data: JobTempRetrieveData, thunkAPI: any) => {
    try {
      const res: any = await JobService.jobTempRetrieve(data);
      if (res.id) {
        return res;
      } else {
        if(res.message) return thunkAPI.rejectWithValue(res.message);
        else return thunkAPI.rejectWithValue(i18n.t('MSG_GLOBAL_DATA_LOAD_FAILED'));
      }
    } catch (error: any) {
      return handleErrorResponse(error, USER_ROLE.COMPANY, thunkAPI);
    }
  },
);

export const deleteJobTemp = createAsyncThunk(
  "deleteJobTemp",
  async (data: JobTempDestroyData, thunkAPI: any) => {
    try {
      const res: any = await JobService.jobTempDestroy(data);
      if (res.success) {
        return res;
      } else {
        if(res.message) return thunkAPI.rejectWithValue(res.message);
        else return thunkAPI.rejectWithValue(i18n.t('MSG_GLOBAL_DATA_LOAD_FAILED'));
      }
    } catch (error: any) {
      return handleErrorResponse(error, USER_ROLE.COMPANY, thunkAPI);
    }
  },
);

export const importAllTempToJob = createAsyncThunk(
  "importAllTempToJob",
  async (data: JobSaveImportCreateData, thunkAPI: any) => {
    try {
      const res: any = await JobService.jobSaveImportCreate(data);
      if (res.success) {
        return res;
      } else {
        if(res.message) return thunkAPI.rejectWithValue(res.message);
        else return thunkAPI.rejectWithValue(i18n.t('MSG_GLOBAL_DATA_LOAD_FAILED'));
      }
    } catch (error: any) {
      return handleErrorResponse(error, USER_ROLE.COMPANY, thunkAPI);
    }
  },
);

export const importPublicAllTempToJob = createAsyncThunk(
  "importPublicAllTempToJob",
  async (data: JobSaveImportPublicCreateData, thunkAPI: any) => {
    try {
      const res: any = await JobService.jobSaveImportPublicCreate(data);
      if (res.success) {
        return res;
      } else {
        if(res.message) return thunkAPI.rejectWithValue(res.message);
        else return thunkAPI.rejectWithValue(i18n.t('MSG_GLOBAL_DATA_LOAD_FAILED'));
      }
    } catch (error: any) {
      return handleErrorResponse(error, USER_ROLE.COMPANY, thunkAPI);
    }
  },
);

export const updatePublicAllTempToJob = createAsyncThunk(
  "updatePublicAllTempToJob",
  async (data: JobSaveImportPublicUpdateData, thunkAPI: any) => {
    try {
      const res: any = await JobService.jobSaveImportPublicUpdate(data);
      if (res.success) {
        return res;
      } else {
        if(res.message) return thunkAPI.rejectWithValue(res.message);
        else return thunkAPI.rejectWithValue(i18n.t('MSG_GLOBAL_DATA_LOAD_FAILED'));
      }
    } catch (error: any) {
      return handleErrorResponse(error, USER_ROLE.COMPANY, thunkAPI);
    }
  },
);

export const publicJobRecord = createAsyncThunk(
  "publicJobRecord",
  async (data: JobImportRecordUpdateData, thunkAPI: any) => {
    try {
      const res: any = await JobService.jobImportRecordUpdate(data);
      if (res.success) {
        return res;
      } else {
        if(res.message) return thunkAPI.rejectWithValue(res.message);
        else return thunkAPI.rejectWithValue(i18n.t('MSG_GLOBAL_DATA_LOAD_FAILED'));
      }
    } catch (error: any) {
      return handleErrorResponse(error, USER_ROLE.COMPANY, thunkAPI);
    }
  },
);

export const publicJobRecordWithSave = createAsyncThunk(
  "publicJobRecordWithSave",
  async (data: JobImportRecordCreateData, thunkAPI: any) => {
    try {
      const res: any = await JobService.jobImportRecordCreate(data);
      if (res.success) {
        return res;
      } else {
        if(res.message) return thunkAPI.rejectWithValue(res.message);
        else return thunkAPI.rejectWithValue(i18n.t('MSG_GLOBAL_DATA_LOAD_FAILED'));
      }
    } catch (error: any) {
      return handleErrorResponse(error, USER_ROLE.COMPANY, thunkAPI);
    }
  },
);

export interface TableHeader {
  title: string;
  isSort: boolean;
  field: string;
  currentSortState: number;
  customStyle1: string;
  customStyle2: string;
  checkPermission: boolean;
}

const initTableHeaders = [
  {
    title: "求人ID",
    isSort: true,
    field: "id",
    currentSortState: 0,
    customStyle1: "w-[5.625rem]",
    customStyle2: "",
    checkPermission: false,
  },
  {
    title: "タイトル",
    isSort: true,
    field: "title",
    currentSortState: 0,
    customStyle1: "min-w-[12rem]",
    customStyle2: "",
    checkPermission: false,
  },
  {
    title: "ステータス",
    isSort: true,
    field: "status",
    currentSortState: 0,
    customStyle1: "w-[9rem]",
    customStyle2: "",
    checkPermission: false,
  },
  {
    title: "形態",
    isSort: true,
    field: "type",
    currentSortState: 0,
    customStyle1: "w-[8rem]",
    customStyle2: "",
    checkPermission: false,
  },
  {
    title: "職種",
    isSort: true,
    field: "occupation_2",
    currentSortState: 0,
    customStyle1: "w-[8rem]",
    customStyle2: "",
    checkPermission: false,
  },
  {
    title: "公開日",
    isSort: true,
    field: "public_date",
    currentSortState: 0,
    customStyle1: "w-[8rem]",
    customStyle2: "",
    checkPermission: false,
  },
  {
    title: "閲覧数",
    isSort: true,
    field: "number_of_views",
    currentSortState: 0,
    customStyle1: "max-w-[6rem] min-w-[4rem]",
    customStyle2: "justify-end",
    checkPermission: false,
  },
  {
    title: "保存数",
    isSort: true,
    field: "number_of_saves",
    currentSortState: 0,
    customStyle1: "max-w-[6rem] min-w-[4rem]",
    customStyle2: "justify-end",
    checkPermission: false,
  },
  {
    title: "応募数",
    isSort: true,
    field: "number_of_responses",
    currentSortState: 0,
    customStyle1: "max-w-[6rem] min-w-[4rem]",
    customStyle2: "justify-end",
    checkPermission: false,
  },
  {
    title: "",
    isSort: false,
    field: "",
    currentSortState: 0,
    customStyle1: "w-[5rem]",
    customStyle2: "",
    checkPermission: false,
  },
  {
    title: "",
    isSort: false,
    field: "",
    currentSortState: 0,
    customStyle1: "w-[5rem]",
    customStyle2: "",
    checkPermission: true,
  },
];


// Initial state of Redux
interface JobState {
  loading: boolean;
  error: string | null;
  success: string | null;
  optionsMaster: [];
  optionsProfesstion: [];
  optionsIndustry: [];
  jobDetailData: [];
  jobDetailDataTemp: any;
  isNavigateToPreview: boolean;
  isNavigateToEdit: boolean;
  jobListData: [];
  countItems: number;
  currentPage: number;
  pageSize: number;
  sortBy: string | null;
  sortOrder: string | null;
  searchQuery: string | null;
  filterOption: {} | null;
  jobDetailTempData: [];
  dataImportCSV: [];
  savedCSV: boolean;
  publishedCSV: boolean;
  listImportSuccess: [];
  listImportError: [];
  resultImport: any;
  actionStatus: string;
  actionName: string;
  currentPageSuccess: number;
  currentPageError: number;
  file: any;
  publishedRecordsTemp: any;
  tableHeaders: TableHeader[];
  itemNameDelete: string;
  isReloadJobList: boolean;
  reloadDetailPage: boolean;
  isChangeBeforePreview: boolean;
  isPublishedItem: boolean;
  jobRankAOnly: number;
  jobSelectedTypeOfTalent: any;
}

const initialState: JobState = {
  loading: false,
  error: null,
  success: null,
  optionsMaster: [],
  optionsProfesstion: [],
  optionsIndustry: [],
  jobDetailData: [],
  jobDetailDataTemp: null,
  isNavigateToPreview: false,
  isNavigateToEdit: false,
  jobListData: [],
  countItems: 0,
  currentPage: 1,
  pageSize: 10,
  sortBy: null,
  sortOrder: null,
  searchQuery: "",
  filterOption: null,
  jobDetailTempData: [],
  dataImportCSV: [],
  savedCSV: false,
  publishedCSV: false,
  listImportSuccess: [],
  listImportError: [],
  resultImport: {},
  actionStatus: "idle", // 'idle' | 'loading' | 'succeeded' | 'failed'
  actionName: "",
  currentPageSuccess: 1,
  currentPageError: 1,
  file: null,
  publishedRecordsTemp: [],
  tableHeaders: initTableHeaders,
  itemNameDelete: "",
  isReloadJobList: false,
  reloadDetailPage: true,
  isChangeBeforePreview: false,
  isPublishedItem: false,
  jobRankAOnly: 0,
  jobSelectedTypeOfTalent: null,
};

const sortingStates = ["default", "desc", "asc"];

export const companyJobSlice = createSlice({
    name: "companyJob",
    initialState,
    reducers: {
      setErrorMsg: (state, action) => {
        state.error = action.payload;
      },
      setIsNavigateToPreview: (state, action) => {
        state.isNavigateToPreview = action.payload;
      },
      setIsNavigateToEdit: (state, action) => {
        state.isNavigateToEdit = action.payload;
      },
      setCurrentPage: (state, action) => {
        state.currentPage = action.payload;
      },
      setSortBy: (state, action) => {
        state.sortBy = action.payload;
      },
      setSortOrder: (state, action) => {
        state.sortOrder = action.payload;
      },
      setSearchQuery: (state, action) => {
        state.searchQuery = action.payload;
      },
      setFilterOption: (state, action) => {
        state.filterOption = action.payload;
      },
      setSuccess: (state, action) => {
        state.success = action.payload;
      },
      setError: (state, action) => {
        state.error = action.payload;
      },
      setSavedCSV: (state, action) => {
        state.savedCSV = action.payload;
      },
      setPublishedCSV: (state, action) => {
        state.publishedCSV = action.payload;
      },
      setActionStatus: (state, action) => {
        state.actionStatus = action.payload;
      },
      setListImportError: (state, action) => {
        state.listImportError = action.payload;
      },
      setListImportSuccess: (state, action) => {
        state.listImportSuccess = action.payload;
      },
      setCurrentPageSuccess: (state, action) => {
        state.currentPageSuccess = action.payload;
      },
      setCurrentPageError: (state, action) => {
        state.currentPageError = action.payload;
      },
      setFile: (state, action) => {
        state.file = action.payload;
      },
      setLoading: (state, action) => {
        state.loading = action.payload;
      },
      setActionName: (state, action) => {
        state.actionName = action.payload;
      },
      setJobDetailData: (state, action) => {
        state.jobDetailData = action.payload;
      },
      setResultImport: (state, action) => {
        state.resultImport = action.payload;
      },
      setJobDetailDataTemp: (state, action) => {
        state.jobDetailDataTemp = action.payload;
      },
      handleSortByHeader(state, action) {
        const sortHeader = action.payload;
        state.tableHeaders = state.tableHeaders.map((header, idx) => (header.field === sortHeader.field)
        ? ({...header, currentSortState: (header.currentSortState + 1) % sortingStates.length})
        : ({...header, currentSortState: 0}));
        
        if((sortHeader.currentSortState + 1) % sortingStates.length !== 0) {
          state.sortBy = sortHeader.field;
          state.sortOrder = sortingStates[(sortHeader.currentSortState + 1) % sortingStates.length];
        } else {
          state.sortBy = null;
          state.sortOrder = null;
        }
      },
      setItemNameDelete: (state, action) => {
        state.itemNameDelete = action.payload;
      },
      setIsChangeBeforePreview: (state, action) => {
        state.isChangeBeforePreview = action.payload;
      },
      setIsPublishedItem: (state, action) => {
        state.isPublishedItem = action.payload;
      },
      setJobRankAOnly: (state, action) => {
        state.jobRankAOnly = action.payload;
      },
      setJobSelectedTypeOfTalent: (state, action) => {
        state.jobSelectedTypeOfTalent = action.payload;
      },
    },
    extraReducers: (builder) => {
      builder
      // reset state
      .addCase(resetAppState, () => initialState)

      // getOptionsMaster
      .addCase(getOptionsMaster.pending, (state) => {
          state.loading = true;
          state.error = null;
      })
      .addCase(getOptionsMaster.fulfilled, (state, action) => {
          state.loading = false;
          state.optionsMaster = action.payload;
      })
      .addCase(getOptionsMaster.rejected, (state, action) => {
          state.loading = false;
          state.error = action.payload as string;
      })

      // getProfessionList
      .addCase(getProfessionList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getProfessionList.fulfilled, (state, action) => {
          state.loading = false;
          state.optionsProfesstion = action.payload;
      })
      .addCase(getProfessionList.rejected, (state, action) => {
          state.loading = false;
          state.error = action.payload as string;
      })

      // Get industry List
      .addCase(getIndustryList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getIndustryList.fulfilled, (state, action) => {
          state.loading = false;
          state.optionsIndustry = action.payload;
      })
      .addCase(getIndustryList.rejected, (state, action) => {
          state.loading = false;
          state.error = action.payload as string;
      })

      // createJob
      .addCase(createJob.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.actionName = "createJob";
      })
      .addCase(createJob.fulfilled, (state, action) => {
        state.loading = false;
        state.success = action.payload.message;
        state.jobDetailData = action.payload.data;
      })
      .addCase(createJob.rejected, (state, action) => {
          state.loading = false;
          state.error = action.payload as string;
      })

      // getJobList
      .addCase(getJobList.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.actionName = "getJobList";
        state.actionStatus = "pending";
      })
      .addCase(getJobList.fulfilled, (state, action) => {
        state.loading = false;
        state.jobListData = action.payload.results.data;
        state.countItems = action.payload.count;
        state.actionName = "getJobList";
        state.actionStatus = "fulfilled";
      })
      .addCase(getJobList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
        state.actionName = "getJobList";
        state.actionStatus = "rejected";
      })

      // deleteJobByIds
      .addCase(deleteJobByIds.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.actionName = "deleteJobByIds";
        state.actionStatus = "pending";
      })
      .addCase(deleteJobByIds.fulfilled, (state, action) => {
        state.loading = false;
        state.actionName = "deleteJobByIds";
        state.actionStatus = "fulfilled";
        if(action.payload?.success) {
          state.success = state.itemNameDelete + " 件の求人を削除しました。";
        } else {
          state.error = action.payload?.message
        }
        state.itemNameDelete = "";
        state.isReloadJobList = !state.isReloadJobList;
      })
      .addCase(deleteJobByIds.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
        state.actionName = "deleteJobByIds";
        state.actionStatus = "rejected";
      })

      //updateJobStatus
      .addCase(updateJobStatus.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.isReloadJobList = false;
        state.actionName = "updateJobStatus";
        state.actionStatus = "pending";
      })
      .addCase(updateJobStatus.fulfilled, (state, action) => {
        state.loading = false;
        state.success = action.payload;
        state.isReloadJobList = true;
        state.actionName = "updateJobStatus";
        state.actionStatus = "fulfilled";
      })
      .addCase(updateJobStatus.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
        state.isReloadJobList = false;
        state.actionName = "updateJobStatus";
        state.actionStatus = "rejected";
      })

      //getJobDetail
      .addCase(getJobDetail.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.actionStatus = "pending";
        state.actionName = "getJobDetail";
      })
      .addCase(getJobDetail.fulfilled, (state, action) => {
        state.loading = false;
        state.jobDetailData = action.payload;
        state.actionStatus = "fulfilled";
      })
      .addCase(getJobDetail.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
        state.actionStatus = "rejected";
      })

      //updateJobDetail
      .addCase(updateJobDetail.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = null;
        state.actionName = "updateJobDetail";
      })
      .addCase(updateJobDetail.fulfilled, (state, action) => {
        state.loading = false;
        state.success = action.payload.message;
        state.jobDetailData = action.payload.data;
        state.reloadDetailPage = !state.reloadDetailPage;
      })
      .addCase(updateJobDetail.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })

      //importJobTemp
      .addCase(importJobTemp.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = null;
        state.savedCSV = false;
        state.publishedCSV = false;
        state.currentPageSuccess = 1;
        state.currentPageError = 1;
        state.actionName = "importJobTemp";
      })
      .addCase(importJobTemp.fulfilled, (state, action) => {
        state.loading = false;
        state.resultImport = action.payload.data;
        state.listImportSuccess = state.resultImport
          ? state.resultImport.success_rows.slice(0, state.pageSize)
          : [];
        state.listImportError = state.resultImport
          ? state.resultImport.fail_rows.slice(0, state.pageSize)
          : [];
        state.actionName = "importJobTemp";
        state.actionStatus = "fulfilled";
      })
      .addCase(importJobTemp.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
        state.actionStatus = "rejected";
      })

      //getJobDetailTemp
      .addCase(getJobDetailTemp.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.actionStatus = "pending";
        state.actionName = "getJobDetailTemp";
      })
      .addCase(getJobDetailTemp.fulfilled, (state, action) => {
        state.loading = false;
        state.jobDetailTempData = action.payload;
        state.actionStatus = "fulfilled";
      })
      .addCase(getJobDetailTemp.rejected, (state, action) => {
          state.loading = false;
          state.error = action.payload as string;
          state.actionStatus = "rejected";
      })

      //deleteJobTemp
      .addCase(deleteJobTemp.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = null;
      })
      .addCase(deleteJobTemp.fulfilled, (state, action) => {
        state.loading = false;
        state.resultImport.success_rows = state.resultImport.success_rows.filter((item: any) => item.id !== action.payload.data);
        state.listImportSuccess = state.resultImport
          ? state.resultImport.success_rows.slice(0, state.pageSize)
          : [];
        state.currentPageSuccess = 1;
        state.success = action.payload.message
      })
      .addCase(deleteJobTemp.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
        state.success = null;
      })

      //importAllTempToJob
      .addCase(importAllTempToJob.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = null;
        state.actionName = "importAllTempToJob";
      })
      .addCase(importAllTempToJob.fulfilled, (state, action) => {
        state.loading = false;
        state.success = action.payload.message;
        const { success_rows, job_temp_ids } = action.payload.data;
        const jobTempIdsSet = new Set(job_temp_ids);
        state.resultImport.success_rows = state.resultImport.success_rows.map((item: any) => {
          if (jobTempIdsSet.has(item.id) && !item.id_temp) {
              const updatedItem = success_rows[job_temp_ids.indexOf(item.id)];
              if (updatedItem) {
                return { ...item, ...updatedItem };
              }
          }
          return item;
        });
        const startPageSuccess = (Number(state.currentPageSuccess) - 1) * Number(state.pageSize);
        const endPageSuccess = startPageSuccess + Number(state.pageSize); 
        state.listImportSuccess = state.resultImport
          ? state.resultImport.success_rows.slice(startPageSuccess, endPageSuccess)
          : [];
      })
      .addCase(importAllTempToJob.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
        state.success = null;
      })

      //importPublicAllTempToJob
      .addCase(importPublicAllTempToJob.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = null;
        state.actionName = "importPublicAllTempToJob";
      })
      .addCase(importPublicAllTempToJob.fulfilled, (state, action) => {
        state.loading = false;
        state.success = action.payload.message;
        const { success_rows, job_temp_ids } = action.payload.data;
        const jobTempIdsSet = new Set(job_temp_ids);
        state.resultImport.success_rows = state.resultImport.success_rows.map((item: any) => {
          if (jobTempIdsSet.has(item.id)) {
              const updatedItem = success_rows[job_temp_ids.indexOf(item.id)];
              if (updatedItem) {
                return { ...item, ...updatedItem };
              }
          }
          return item;
        });
        const startPageSuccess = (Number(state.currentPageSuccess) - 1) * Number(state.pageSize);
        const endPageSuccess = startPageSuccess + Number(state.pageSize); 
        state.listImportSuccess = state.resultImport
          ? state.resultImport.success_rows.slice(startPageSuccess, endPageSuccess)
          : [];
      })
      .addCase(importPublicAllTempToJob.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
        state.success = null;
      })

      //updatePublicAllTempToJob
      .addCase(updatePublicAllTempToJob.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = null;
        state.actionName = "updatePublicAllTempToJob";
      })
      .addCase(updatePublicAllTempToJob.fulfilled, (state, action) => {
        state.loading = false;
        state.resultImport = action.payload.data;
        const startPageSuccess = (Number(state.currentPageSuccess) - 1) * Number(state.pageSize);
        const endPageSuccess = startPageSuccess + Number(state.pageSize); 
        state.listImportSuccess = state.resultImport
          ? state.resultImport.success_rows.slice(startPageSuccess, endPageSuccess)
          : [];
        state.success = action.payload.message;
      })
      .addCase(updatePublicAllTempToJob.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
        state.success = null;
      })

      //publicJobRecord
      .addCase(publicJobRecord.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = null;
      })
      .addCase(publicJobRecord.fulfilled, (state, action) => {
        state.loading = false;
        state.success = action.payload.message;
        const updatedRecord = action.payload.data;
        state.resultImport.success_rows = state.resultImport.success_rows.map((record: any) => 
          record.id === updatedRecord.id ? { ...record, ...updatedRecord } : record
        );
        const startPageSuccess = (Number(state.currentPageSuccess) - 1) * Number(state.pageSize);
        const endPageSuccess = startPageSuccess + Number(state.pageSize); 
        state.listImportSuccess = state.resultImport
          ? state.resultImport.success_rows.slice(startPageSuccess, endPageSuccess)
          : [];
      })
      .addCase(publicJobRecord.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
        state.success = null;
      })

      //publicJobRecordWithSave
      .addCase(publicJobRecordWithSave.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = null;
      })
      .addCase(publicJobRecordWithSave.fulfilled, (state, action) => {
        state.loading = false;
        state.success = action.payload.message;
        const updatedRecord = action.payload.data;
        state.resultImport.success_rows = state.resultImport.success_rows.map((record: any) => {
          if (!record.id_temp) {
            if (record.id === updatedRecord.id_temp) {
              return { ...record, ...updatedRecord };
            }
          }
          return record;
        });
        const startPageSuccess = (Number(state.currentPageSuccess) - 1) * Number(state.pageSize);
        const endPageSuccess = startPageSuccess + Number(state.pageSize); 
        state.listImportSuccess = state.resultImport
          ? state.resultImport.success_rows.slice(startPageSuccess, endPageSuccess)
          : [];
      })
      .addCase(publicJobRecordWithSave.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
        state.success = null;
      })
    }
});

export const {
  setErrorMsg, setIsNavigateToPreview, setIsNavigateToEdit, setCurrentPage, setSortBy, setSortOrder,
  setSearchQuery, setFilterOption, setSuccess, setError, setPublishedCSV, setSavedCSV, setActionStatus,
  setListImportError, setListImportSuccess, setCurrentPageSuccess, setCurrentPageError, setFile,
  setLoading, setJobDetailData, handleSortByHeader, setItemNameDelete, setResultImport, setActionName,
  setJobDetailDataTemp, setIsChangeBeforePreview, setIsPublishedItem, setJobRankAOnly, setJobSelectedTypeOfTalent
} = companyJobSlice.actions;
export default companyJobSlice.reducer;